/* Tema Maestro — JS (sin apps, sin dependencias) */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const T = window.theme || {};

  /* ---------------- Dinero ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);
    format = format || T.moneyFormat || '${{amount}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (n, dec = 2, th = ',', dc = '.') => {
      const num = (n / 100).toFixed(dec);
      const [i, d] = num.split('.');
      return i.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (d ? dc + d : '');
    };
    const m = format.match(re);
    let v = '';
    switch (m && m[1]) {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(re, v);
  }
  window.formatMoney = formatMoney;
  // Estilo Shrine: $34 en vez de $34.00 en ofertas
  const fmtOffer = (c) => (T.look === 'shrine' && Math.round(c) % 100 === 0) ? formatMoney(c).replace(/[.,]00(?=\D*$)/, '') : formatMoney(c);

  const toast = (msg) => {
    const t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('is-visible'), 2200);
  };

  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------------- Contadores ---------------- */
  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
  function initCountdowns() {
    $$('[data-countdown]').forEach((el) => {
      const mode = el.dataset.mode;
      let end;
      if (mode === 'evergreen') {
        const key = 'cd_' + el.dataset.key;
        const mins = Number(el.dataset.minutes || 30);
        end = Number(store.get(key));
        if (!end || end < Date.now()) { end = Date.now() + mins * 60000; store.set(key, String(end)); }
      } else if (mode === 'fixed') {
        end = new Date(el.dataset.end || '').getTime();
        if (!end || end < Date.now()) { const bar = el.closest('.flash, .announce, section') || el; bar.style.display = 'none'; return; }
      } else {
        const d = new Date(); d.setHours(23, 59, 59, 999); end = d.getTime();
      }
      const D = $('[data-d]', el), H = $('[data-h]', el), M = $('[data-m]', el), S = $('[data-s]', el);
      const tick = () => {
        let left = Math.max(0, end - Date.now());
        if (left === 0 && mode === 'evergreen') { end = Date.now() + Number(el.dataset.minutes || 30) * 60000; store.set('cd_' + el.dataset.key, String(end)); left = end - Date.now(); }
        const s = Math.floor(left / 1000);
        const days = Math.floor(s / 86400), hrs = Math.floor((s % 86400) / 3600), min = Math.floor((s % 3600) / 60), sec = s % 60;
        if (D) D.textContent = pad(days);
        if (H) H.textContent = pad(D ? hrs : hrs + days * 24);
        if (M) M.textContent = pad(min);
        if (S) S.textContent = pad(sec);
      };
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------------- Header ---------------- */
  function initHeader() {
    const h = $('[data-header]');
    if (h) {
      const on = () => h.classList.toggle('is-scrolled', window.scrollY > 4);
      on(); window.addEventListener('scroll', on, { passive: true });
      // Encabezado que se oculta al bajar y reaparece al subir
      const wrap = h.closest('.shopify-section') || h;
      if (document.documentElement.dataset.sticky === 'scroll-up') {
        let last = window.scrollY;
        window.addEventListener('scroll', () => {
          const y = window.scrollY, dn = y > last && y > 160;
          if (Math.abs(y - last) > 6) { wrap.classList.toggle('is-hidden', dn && !document.body.style.overflow); last = y; }
        }, { passive: true });
      }
    }
    const nav = $('[data-mnav]');
    if (nav) {
      $$('[data-open-mnav]').forEach((b) => b.addEventListener('click', () => { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }));
      $$('[data-close-mnav]', nav).forEach((b) => b.addEventListener('click', () => { nav.classList.remove('is-open'); document.body.style.overflow = ''; }));
    }
  }

  /* ---------------- Galería ---------------- */
  function initGallery(root) {
    const track = $('[data-gallery-track]', root); if (!track) return null;
    const slides = $$('.gallery__slide', track);
    const thumbs = $$('[data-thumb]', root);
    const idx = () => Math.round(track.scrollLeft / track.clientWidth);
    const go = (i) => { i = (i + slides.length) % slides.length; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
    const sync = () => {
      const i = idx();
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      const a = thumbs[i]; if (a && a.parentElement) a.parentElement.scrollTo({ left: a.offsetLeft - a.parentElement.clientWidth / 2 + a.clientWidth / 2, behavior: 'smooth' });
      slides.forEach((s, k) => { const v = $('video', s); if (v) { k === i ? v.play().catch(() => {}) : v.pause(); } });
    };
    let raf; track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.thumb))));
    const prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    prev && prev.addEventListener('click', () => go(idx() - 1));
    next && next.addEventListener('click', () => go(idx() + 1));
    return {
      toMedia(id) { if (!id) return; const i = slides.findIndex((s) => s.dataset.mediaId === String(id)); if (i >= 0) go(i); }
    };
  }

  /* ---------------- Sliders simples ---------------- */
  function initSliders() {
    $$('[data-slider]').forEach((wrap) => {
      const track = $('[data-slider-track]', wrap); if (!track) return;
      const prev = $('[data-slider-prev]', wrap), next = $('[data-slider-next]', wrap);
      const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; };
      const upd = () => {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        const nav = $('.slider-nav', wrap); if (nav) nav.hidden = track.scrollWidth <= track.clientWidth + 2;
      };
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd); upd();
      if (wrap.dataset.autoplay === 'true') {
        const sp = Number(wrap.dataset.speed || 5) * 1000;
        let h = setInterval(() => { if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) track.scrollTo({ left: 0, behavior: 'smooth' }); else track.scrollBy({ left: step(), behavior: 'smooth' }); }, sp);
        wrap.addEventListener('pointerenter', () => clearInterval(h));
      }
    });
  }

  /* ---------------- Reseñas rotativas (producto) ---------------- */
  function initReviewSliders() {
    $$('[data-rslider]').forEach((root) => {
      const track = $('[data-rslider-track]', root), dotsEl = $('[data-rslider-dots]', root);
      const slides = Array.from(track.children);
      if (slides.length < 2) { dotsEl.hidden = true; return; }
      const dots = slides.map((_, i) => { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', String(i + 1)); b.addEventListener('click', () => go(i)); dotsEl.appendChild(b); return b; });
      const idx = () => Math.round(track.scrollLeft / track.clientWidth);
      const go = (i) => track.scrollTo({ left: ((i + slides.length) % slides.length) * track.clientWidth, behavior: 'smooth' });
      const sync = () => dots.forEach((d, k) => d.classList.toggle('is-active', k === idx()));
      track.addEventListener('scroll', sync, { passive: true }); sync();
      if (root.dataset.autoplay === 'true') {
        let h = setInterval(() => go(idx() + 1), 5000);
        root.addEventListener('pointerdown', () => clearInterval(h), { once: true });
      }
    });
  }

  /* ================================================================
     CARRITO
     ================================================================ */
  const Cart = {
    drawer: null, strings: {}, productCache: {}, busy: false,

    init() {
      this.drawer = $('[data-cart-drawer]');
      try { this.strings = JSON.parse(($('[data-cart-strings]') || {}).textContent || '{}'); } catch (e) {}
      document.addEventListener('click', (e) => {
        const open = e.target.closest('[data-open-cart]');
        if (open && this.drawer) { e.preventDefault(); this.open(); }
        if (e.target.closest('[data-close-cart]')) { e.preventDefault(); this.close(); }
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      if (!this.drawer) return;
      this.drawer.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-qty-btn]');
        if (btn) { const line = btn.closest('[data-line]'); const q = Number(line.dataset.qty) + Number(btn.dataset.qtyBtn); this.change(line.dataset.key, Math.max(0, q)); }
        const rm = e.target.closest('[data-remove]');
        if (rm) { this.change(rm.closest('[data-line]').dataset.key, 0); }
      });
      this.drawer.addEventListener('change', (e) => {
        const inp = e.target.closest('[data-qty-input]');
        if (inp) this.change(inp.closest('[data-line]').dataset.key, Math.max(0, parseInt(inp.value, 10) || 0));
      });
      // Mantener regalos correctos si el carrito cambió en otra pestaña o página
      this.fetch().then((c) => this.syncGifts(c)).then((c) => c && this.updateCount(c)).catch(() => {});
    },

    async fetch() { const r = await fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } }); return r.json(); },

    async post(url, body) {
      const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'Error');
      return j;
    },

    async open() {
      if (!this.drawer) { location.href = T.routes.cart; return; }
      this.drawer.classList.add('is-open'); this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.startTimer();
      this.drawer.classList.add('is-loading');
      try { const c = await this.fetch(); await this.render(c); } finally { this.drawer.classList.remove('is-loading'); }
    },

    close() {
      if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open'); this.drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },

    startTimer() {
      const el = $('[data-cart-timer]', this.drawer); if (!el) return;
      const mins = Number(T.cartTimerMinutes || 0); if (!mins) return;
      let end = Number(store.sget('cart_timer_end'));
      if (!end || end <= Date.now()) { end = Date.now() + mins * 60000; store.sset('cart_timer_end', String(end)); }
      const out = $('[data-cart-timer-time]', el);
      el.hidden = false;
      const tick = () => {
        if (end <= Date.now()) { end = Date.now() + mins * 60000; store.sset('cart_timer_end', String(end)); }
        const s = Math.max(0, Math.floor((end - Date.now()) / 1000)); out.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
      };
      tick(); clearInterval(this._timer); this._timer = setInterval(tick, 1000);
    },

    async change(key, quantity) {
      if (this.busy) return; this.busy = true;
      this.drawer && this.drawer.classList.add('is-loading');
      try {
        let c = await this.post(T.routes.cartChange, { id: key, quantity });
        c = await this.syncGifts(c);
        await this.render(c);
      } catch (e) { toast(e.message); }
      finally { this.busy = false; this.drawer && this.drawer.classList.remove('is-loading'); }
    },

    /* Regalos: agrega o quita según la cantidad del producto principal */
    async syncGifts(cart) {
      if (!cart || !cart.attributes) return cart;
      let changed = false;
      for (const k of Object.keys(cart.attributes)) {
        if (!k.startsWith('_gifts_')) continue;
        const pid = k.slice(7);
        let rules = [];
        try { rules = JSON.parse(cart.attributes[k]) || []; } catch (e) { continue; }
        const mainQty = cart.items.filter((i) => String(i.product_id) === pid && !(i.properties && i.properties._gift)).reduce((a, i) => a + i.quantity, 0);
        const giftLines = cart.items.filter((i) => i.properties && i.properties._gift && String(i.properties._gift_for) === pid);
        const want = rules.filter((r) => mainQty > 0 && mainQty >= Number(r.min)).map((r) => String(r.v));
        for (const g of giftLines) {
          if (!want.includes(String(g.variant_id))) { await this.post(T.routes.cartChange, { id: g.key, quantity: 0 }); changed = true; }
          else if (g.quantity !== 1) { await this.post(T.routes.cartChange, { id: g.key, quantity: 1 }); changed = true; }
        }
        const have = giftLines.map((g) => String(g.variant_id));
        const missing = want.filter((v, i, a) => a.indexOf(v) === i && !have.includes(v));
        if (missing.length) {
          try { await this.post(T.routes.cartAdd, { items: missing.map((v) => ({ id: Number(v), quantity: 1, properties: { _gift: '1', _gift_for: pid } })) }); changed = true; } catch (e) { console.warn('Gift add failed', e); }
        }
      }
      return changed ? this.fetch() : cart;
    },

    async compareAt(item) {
      const h = item.handle;
      if (!(h in this.productCache)) {
        this.productCache[h] = fetch(T.routes.root.replace(/\/$/, '') + '/products/' + h + '.js').then((r) => r.ok ? r.json() : null).catch(() => null);
      }
      const p = await this.productCache[h];
      if (!p) return 0;
      const v = (p.variants || []).find((x) => x.id === item.variant_id);
      return v && v.compare_at_price ? v.compare_at_price : 0;
    },

    updateCount(cart) {
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count > 0 ? cart.item_count : ''; el.dataset.count = cart.item_count; });
      const dc = $('[data-drawer-count]'); if (dc) dc.textContent = cart.item_count > 0 ? '• ' + cart.item_count + ' ' + (this.strings.items || 'items') : '';
    },

    async render(cart) {
      this.updateCount(cart);
      if (!this.drawer) return;
      const body = $('[data-cart-body]', this.drawer), foot = $('[data-cart-foot]', this.drawer);
      if (!cart.items.length) {
        body.innerHTML = $('[data-cart-empty-tpl]').innerHTML; foot.hidden = true; return;
      }
      const compares = await Promise.all(cart.items.map((i) => this.compareAt(i)));
      let totalSave = 0;
      const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      // regalos al final
      const order = cart.items.map((it, i) => ({ it, i })).sort((a, b) => (!!(a.it.properties && a.it.properties._gift)) - (!!(b.it.properties && b.it.properties._gift)));
      body.innerHTML = order.map(({ it, i }) => {
        const gift = it.properties && it.properties._gift;
        const unitRef = Math.max(compares[i] || 0, it.original_price);
        const compareLine = unitRef * it.quantity;
        const finalLine = it.final_line_price;
        const save = Math.max(0, compareLine - finalLine);
        totalSave += save;
        const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        const variant = it.variant_title && !/default title/i.test(it.variant_title) ? `<div class="citem__variant">${esc(it.variant_title)}</div>` : '';
        const props = it.properties ? Object.entries(it.properties).filter(([k, v]) => k[0] !== '_' && v).map(([k, v]) => `<div class="citem__variant">${esc(k)}: ${esc(v)}</div>`).join('') : '';
        const priceHtml = gift
          ? `<div class="citem__prices">${compareLine > 0 ? `<div class="citem__compare">${formatMoney(compareLine)}</div>` : ''}<div class="citem__free">${esc(finalLine > 0 ? formatMoney(finalLine) : (this.strings.free || 'FREE'))}</div></div>`
          : `<div class="citem__prices">${save > 0 ? `<div class="citem__compare">${formatMoney(compareLine)}</div>` : ''}<div class="citem__price">${formatMoney(finalLine)}</div>${save > 0 ? `<div class="citem__save">(${esc(this.strings.save || 'You save')} ${formatMoney(save)})</div>` : ''}</div>`;
        return `<div class="citem" data-line data-key="${esc(it.key)}" data-qty="${it.quantity}">
          <a class="citem__img" href="${esc(it.url)}">${img ? `<img src="${esc(img)}" alt="${esc(it.product_title)}" loading="lazy" width="76" height="76">` : ''}</a>
          <div>
            <a class="citem__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
            ${variant}${props}
            ${gift ? `<div class="citem__gift"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v9h14v-9"/></svg>${esc(this.strings.gift || 'Free gift')}</div>`
              : `<div class="qty"><button type="button" data-qty-btn="-1" aria-label="-"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg></button><input type="number" min="0" value="${it.quantity}" data-qty-input aria-label="Qty"><button type="button" data-qty-btn="1" aria-label="+"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg></button></div>`}
          </div>
          <div class="citem__right">
            ${gift ? '<span></span>' : `<button type="button" class="citem__remove" data-remove aria-label="${esc(this.strings.remove || 'Remove')}"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg></button>`}
            ${priceHtml}
          </div>
        </div>`;
      }).join('');
      // descuentos de carrito (no de línea)
      const cartLevel = (cart.cart_level_discount_applications || []).reduce((a, d) => a + (d.total_allocated_amount || 0), 0);
      totalSave += cartLevel;
      $('[data-cart-total]', this.drawer).textContent = formatMoney(cart.total_price);
      const sv = $('[data-cart-savings]', this.drawer);
      sv.hidden = totalSave <= 0;
      $('[data-cart-savings-amount]', this.drawer).textContent = '-' + formatMoney(totalSave);
      foot.hidden = false;
      this.renderShipbar(cart);
      this.renderUpsell(cart);
    },

    renderShipbar(cart) {
      const bar = $('[data-shipbar]', this.drawer); if (!bar) return;
      const goal = Number(this.strings.shipThreshold || 0);
      if (!goal || !cart.items.length) { bar.hidden = true; return; }
      const total = cart.items_subtotal_price - ((cart.cart_level_discount_applications || []).reduce((a, d) => a + (d.total_allocated_amount || 0), 0));
      const left = goal - total;
      bar.hidden = false;
      bar.classList.toggle('is-done', left <= 0);
      $('[data-shipbar-text]', bar).innerHTML = left <= 0
        ? (this.strings.shipDone || '')
        : (this.strings.shipProgress || '').replace('[amount]', '<b>' + formatMoney(left) + '</b>');
      $('[data-shipbar-fill]', bar).style.width = Math.max(4, Math.min(100, (total / goal) * 100)) + '%';
    },

    renderUpsell(cart) {
      const up = $('[data-upsell]', this.drawer); if (!up) return;
      const inCart = cart.items.some((i) => String(i.product_id) === up.dataset.productId);
      up.hidden = inCart || !cart.items.length;
      if (!up._bound) {
        up._bound = true;
        $('[data-upsell-add]', up).addEventListener('click', async (e) => {
          if (up.dataset.single !== 'true') { location.href = up.dataset.url; return; }
          const b = e.currentTarget; b.classList.add('is-loading');
          try { await this.post(T.routes.cartAdd, { items: [{ id: Number(up.dataset.variantId), quantity: 1 }] }); await this.render(await this.fetch()); }
          catch (err) { toast(err.message); } finally { b.classList.remove('is-loading'); }
        });
      }
    }
  };
  window.ThemeCart = Cart;

  /* ================================================================
     FORMULARIO DE PRODUCTO (ofertas + regalos)
     ================================================================ */
  class ProductForm {
    constructor(el) {
      this.el = el;
      this.section = el.closest('[data-product-section]');
      try { this.data = JSON.parse($('[data-product-json]', el).textContent); } catch (e) { return; }
      this.variants = this.data.variants;
      this.variant = this.variants.find((v) => v.id === this.data.selected) || this.variants[0];
      this.gallery = initGallery($('[data-gallery]', this.section));
      this.bundle = $('[data-bundle]', el);
      this.offers = this.bundle ? $$('[data-offer]', this.bundle) : [];
      this.gifts = $$('[data-gift]', el);
      this.atc = $('[data-add-to-cart]', el);

      // Ofertas
      this.offers.forEach((o) => {
        o.addEventListener('click', (e) => { if (e.target.closest('select')) return; this.selectOffer(o); });
        $$('[data-unit-select]', o).forEach((s) => s.addEventListener('change', () => {
          const v = this.byId(s.value); if (v) { this.variant = v; if (v.media_id && this.gallery) this.gallery.toMedia(v.media_id); }
          this.refresh();
        }));
        // Un selector por opción (Color / Talla): arma la variante y la pone en el selector oculto
        $$('[data-unit]', o).forEach((u) => {
          const opts = $$('[data-unit-opt]', u); if (!opts.length) return;
          const hidden = $('[data-unit-select]', u);
          opts.forEach((sel) => sel.addEventListener('change', () => {
            const vals = opts.map((x) => x.value);
            const v = this.variants.find((x) => x.options.every((ov, i) => ov === vals[i]));
            hidden.value = v ? v.id : '';
            hidden.dispatchEvent(new Event('change'));
          }));
        });
      });
      if (this.offers.length && !this.offers.some((o) => o.classList.contains('is-selected'))) this.offers[0].classList.add('is-selected');

      // Selector normal
      $$('[data-variant-picker] input', el).forEach((inp) => inp.addEventListener('change', () => this.onOptionChange()));

      this.atc && this.atc.addEventListener('click', () => this.add());
      this.initSticky();
      this.refresh(true);
    }

    byId(id) { return this.variants.find((v) => String(v.id) === String(id)); }
    selected() { return this.offers.find((o) => o.classList.contains('is-selected')); }
    qty() { const o = this.selected(); return o ? Number(o.dataset.qty) : 1; }

    selectOffer(o) {
      if (o.classList.contains('is-selected')) return;
      this.offers.forEach((x) => { x.classList.toggle('is-selected', x === o); const r = $('input[type=radio]', x); if (r) r.checked = x === o; });
      // los selectores de la nueva oferta copian la variante actual
      $$('[data-unit]', o).forEach((u) => {
        const s = $('[data-unit-select]', u); if (!s || !this.variant || !this.variant.available) return;
        s.value = this.variant.id;
        $$('[data-unit-opt]', u).forEach((x) => { x.value = this.variant.options[Number(x.dataset.unitOpt)]; });
      });
      this.refresh();
    }

    onOptionChange() {
      const vals = this.data.options.map((_, i) => { const c = $(`[data-variant-picker] input[data-option-index="${i}"]:checked`, this.el); return c ? c.value : null; });
      const v = this.variants.find((x) => x.options.every((o, i) => o === vals[i]));
      vals.forEach((val, i) => { const l = $(`[data-option-value="${i}"]`, this.el); if (l) l.textContent = val; });
      if (v) { this.variant = v; if (v.media_id && this.gallery) this.gallery.toMedia(v.media_id); }
      else this.variant = null;
      this.refresh();
    }

    unitVariants(o) {
      const sels = o ? $$('[data-unit-select]', o) : [];
      if (sels.length) return sels.map((s) => this.byId(s.value) || null);
      const q = o ? Number(o.dataset.qty) : 1;
      return Array.from({ length: q }, () => this.variant);
    }

    offerTotals(o) {
      const units = this.unitVariants(o);
      const base = units.reduce((a, v) => a + (v ? v.price : 0), 0);
      const compare = units.reduce((a, v) => a + (v ? Math.max(v.compare_at_price || 0, v.price) : 0), 0);
      const pct = Number(o.dataset.pct || 0);
      const off = pct > 0 ? Math.round(base * pct / 100) : Number(o.dataset.off || 0);
      const final = Math.max(0, base - off);
      return { final, compare, saved: Math.max(0, compare - final), pct: compare > 0 ? Math.round((compare - final) * 100 / compare) : 0, available: units.every((v) => v && v.available), units };
    }

    fill(tpl, t, q) { return (tpl || '').replace(/\[quantity\]/g, q).replace(/\[amount_saved\]/g, fmtOffer(t.saved)).replace(/\[percent\]/g, t.pct); }

    refresh(first) {
      let price, compare, available;
      if (this.offers.length) {
        this.offers.forEach((o) => {
          const t = this.offerTotals(o), q = o.dataset.qty;
          $('[data-offer-price]', o).textContent = fmtOffer(t.final);
          const c = $('[data-offer-compare]', o); c.textContent = fmtOffer(t.compare); c.hidden = t.compare <= t.final;
          const lab = $('[data-offer-label]', o); if (lab && !first) lab.innerHTML = this.fill(lab.dataset.template, t, q);
          const cap = $('[data-offer-caption]', o); if (cap && !first) cap.innerHTML = this.fill(cap.dataset.template, t, q);
          const sv = $('[data-offer-save]', o); if (sv) { sv.textContent = this.fill(sv.dataset.template, t, q); sv.hidden = t.saved <= 0; }
          const img = $('[data-offer-img] img', o);
          if (img && !o.dataset.customImg && t.units[0] && t.units[0].image) img.src = t.units[0].image;
        });
        const t = this.offerTotals(this.selected());
        price = t.final; compare = t.compare; available = t.available;
      } else {
        const v = this.variant;
        available = !!(v && v.available);
        price = v ? v.price : 0; compare = v ? v.compare_at_price : 0;
        const p = $('[data-price]', this.el); if (p && v) p.textContent = formatMoney(v.price);
        const c = $('[data-compare]', this.el);
        if (c && v) { c.hidden = !(v.compare_at_price > v.price); c.textContent = formatMoney(v.compare_at_price); }
        const pill = $('[data-save-pill]', this.el);
        if (pill && v) { pill.hidden = !(v.compare_at_price > v.price); const pc = v.compare_at_price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0; pill.textContent = (pill.dataset.template || '').replace('[percent]', pc).replace('[amount]', formatMoney(v.compare_at_price - v.price)); }
      }
      // Precio del bloque "Precio" también sigue la variante cuando hay ofertas
      if (this.offers.length) {
        const showUnit = this.el.dataset.displayUnitPrice === 'true';
        const displayedPrice = showUnit && this.variant ? this.variant.price : price;
        const displayedCompare = showUnit && this.variant ? this.variant.compare_at_price : compare;
        const p = $('[data-price]', this.el); if (p) p.textContent = formatMoney(displayedPrice);
        const c = $('[data-compare]', this.el); if (c) { c.hidden = !(displayedCompare > displayedPrice); c.textContent = formatMoney(displayedCompare); }
        const pill = $('[data-save-pill]', this.el); if (pill) { pill.hidden = !(displayedCompare > displayedPrice); pill.textContent = (pill.dataset.template || '').replace('[percent]', displayedCompare ? Math.round((displayedCompare-displayedPrice)*100/displayedCompare) : 0).replace('[amount]', formatMoney(displayedCompare-displayedPrice)); }
      }
      // Botón
      if (this.atc) {
        this.atc.disabled = !available;
        const txt = $('[data-atc-text]', this.atc);
        if (txt) txt.innerHTML = available ? (this.atc.dataset.label + (this.atc.dataset.showPrice === 'true' ? ' <span class="atc__price-sep">·</span> ' + formatMoney(price) : '')) : (T.strings && T.strings.soldOut || 'Sold out');
      }
      // Barra fija
      const sp = $('[data-sticky-price]', this.section), sc = $('[data-sticky-compare]', this.section);
      if (sp) sp.textContent = formatMoney(price);
      if (sc) sc.textContent = compare > price ? formatMoney(compare) : '';
      // Regalos (por cantidad y, si se activa, por modelo: gana el mayor)
      const q = this.qty(), lvl = this.modelLevel();
      this.gifts.forEach((g) => {
        const locked = !(q >= Number(g.dataset.min || 1) || lvl >= Number(g.dataset.min || 1));
        if (!locked && g.classList.contains('is-locked') && !first) { g.classList.remove('just-unlocked'); void g.offsetWidth; g.classList.add('just-unlocked'); }
        g.classList.toggle('is-locked', locked);
      });
    }

    /* Nivel de modelo = posición (1, 2, 3…) de la mejor variante elegida entre las unidades */
    modelLevel() {
      const box = $('[data-gifts]', this.el);
      if (!box || box.dataset.byModel !== 'true') return 0;
      const units = this.offers.length ? this.unitVariants(this.selected()) : [this.variant];
      return units.reduce((m, v) => Math.max(m, v ? this.variants.indexOf(v) + 1 : 0), 0);
    }

    async add() {
      if (!this.atc || this.atc.disabled) return;
      const o = this.selected();
      const units = this.offers.length ? this.offerTotals(o).units : [this.variant];
      if (!units.length || units.some((v) => !v)) return;
      const grouped = {};
      units.forEach((v) => { grouped[v.id] = (grouped[v.id] || 0) + 1; });
      const items = Object.entries(grouped).map(([id, quantity]) => ({ id: Number(id), quantity }));
      const pid = String(this.data.id);
      const lvl = this.modelLevel();
      const rules = this.gifts.filter((g) => g.dataset.variant).map((g) => { const min = Number(g.dataset.min || 1); return { v: Number(g.dataset.variant), min: lvl >= min ? 1 : min }; });

      this.atc.classList.add('is-loading');
      try {
        if (rules.length) await Cart.post(T.routes.cartUpdate, { attributes: { ['_gifts_' + pid]: JSON.stringify(rules) } });
        await Cart.post(T.routes.cartAdd, { items });
        let cart = await Cart.fetch();
        cart = await Cart.syncGifts(cart);
        Cart.updateCount(cart);
        if (Cart.drawer) { await Cart.open(); } else { location.href = T.routes.cart; }
      } catch (e) {
        toast(e.message);
      } finally { this.atc.classList.remove('is-loading'); }
    }

    initSticky() {
      const bar = $('[data-sticky-atc]', this.section); if (!bar || !this.atc) return;
      const btn = $('[data-sticky-btn]', bar);
      const io = new IntersectionObserver(([e]) => {
        const past = e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !e.isIntersecting && past);
      }, { threshold: 0 });
      io.observe(this.atc);
      btn.addEventListener('click', () => {
        if (btn.dataset.mode === 'scroll') {
          (this.bundle || this.atc).scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else this.add();
      });
    }
  }

  /* ---------------- FAQ: abrir uno a la vez (opcional) ---------------- */
  function initAccordions() {
    $$('[data-accordion-single]').forEach((group) => {
      const items = $$('details', group);
      items.forEach((d) => d.addEventListener('toggle', () => { if (d.open) items.forEach((x) => { if (x !== d) x.open = false; }); }));
    });
  }

  /* Barra de progreso de scroll */
  function initScrollProgress() {
    const bar = $('[data-scroll-progress] span'); if (!bar || bar._init) return; bar._init = true;
    const upd = () => { const h = document.documentElement.scrollHeight - window.innerHeight; bar.style.width = (h > 0 ? Math.min(100, window.scrollY / h * 100) : 0) + '%'; };
    window.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }

  /* Puntos de características */
  function initHotspots() {
    $$('[data-hotspots]').forEach((box) => {
      if (box._init) return; box._init = true;
      const pins = $$('.hs__pin', box);
      box.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-hs-dot]');
        pins.forEach((p) => { const on = dot && p.contains(dot) && !p.classList.contains('is-open'); p.classList.toggle('is-open', !!on); $('[data-hs-dot]', p).setAttribute('aria-expanded', String(!!on)); });
      });
      document.addEventListener('click', (e) => { if (!box.contains(e.target)) pins.forEach((p) => p.classList.remove('is-open')); });
    });
  }

  /* Slideshow */
  function initSlideshows() {
    $$('[data-slideshow]').forEach((root) => {
      if (root._init) return; root._init = true;
      const track = $('[data-ss-track]', root), slides = $$('.sshow__slide', track), dots = $('[data-ss-dots]', root);
      if (!track || slides.length < 2) return;
      const idx = () => Math.round(track.scrollLeft / track.clientWidth);
      const go = (i) => track.scrollTo({ left: ((i + slides.length) % slides.length) * track.clientWidth, behavior: 'smooth' });
      const btns = slides.map((_, i) => { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', String(i + 1)); b.addEventListener('click', () => go(i)); dots && dots.appendChild(b); return b; });
      const sync = () => btns.forEach((b, i) => b.classList.toggle('is-on', i === idx()));
      track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true }); sync();
      if (root.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let h = setInterval(() => go(idx() + 1), Number(root.dataset.speed || 5) * 1000);
        root.addEventListener('pointerdown', () => clearInterval(h), { once: true });
      }
    });
  }

  /* Fechas de entrega estimadas */
  function initShipSteps() {
    $$('[data-ship-steps]').forEach((box) => {
      if (box._init) return; box._init = true;
      const months = (box.dataset.months || '').split(',').map((x) => x.trim());
      const fmt = (d) => (months[d.getMonth()] || (d.getMonth() + 1)) + ' ' + d.getDate();
      const add = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
      $$('.ship-steps__step', box).forEach((st) => {
        const t = $('[data-ss-top]', st), mn = Number(st.dataset.min || 0), mx = Math.max(mn, Number(st.dataset.max || 0));
        t.innerHTML = (t.dataset.tpl || '').replace(/\[start_date\]/g, fmt(add(mn))).replace(/\[end_date\]/g, fmt(add(mx)));
      });
    });
  }

  /* Seguimiento de pedido */
  function initTrack() {
    $$('[data-track-form]').forEach((f) => {
      if (f._init) return; f._init = true;
      f.addEventListener('submit', (e) => {
        e.preventDefault();
        const n = encodeURIComponent($('[data-track-input]', f).value.trim()); if (!n) return;
        const url = (f.dataset.url || '').replace('NUMBER', n);
        if (/^https?:\/\//i.test(url)) window.open(url, '_blank', 'noopener');
      });
    });
  }

  /* Filtros y orden de colección */
  function initFilters() {
    $$('[data-filter-form]').forEach((f) => {
      if (f._init) return; f._init = true;
      const panel = $('[data-filter-panel]', f), tg = $('[data-filter-toggle]', f);
      if (tg && panel) {
        const anyActive = $$('input:checked', panel).length || $$('input[type=number]', panel).some((i) => i.value);
        if (anyActive) { panel.hidden = false; tg.setAttribute('aria-expanded', 'true'); }
        tg.addEventListener('click', () => { panel.hidden = !panel.hidden; tg.setAttribute('aria-expanded', String(!panel.hidden)); });
      }
      let h;
      f.addEventListener('change', (e) => {
        if (!e.target.closest('[data-filter-auto]')) return;
        clearTimeout(h); h = setTimeout(() => {
          const params = new URLSearchParams();
          new FormData(f).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
          location.search = params.toString();
        }, 250);
      });
      f.addEventListener('submit', (e) => e.preventDefault());
    });
  }

  /* Buscador en vivo */
  function initSearch() {
    const pop = $('[data-search-pop]'); if (!pop || pop._init) return; pop._init = true;
    const input = $('[data-search-input]', pop), out = $('[data-search-results]', pop);
    const open = () => { pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false'); setTimeout(() => input.focus(), 80); };
    const close = () => { pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true'); };
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-open-search]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-close-search]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    const esc = (v) => String(v == null ? '' : v).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    let h, seq = 0;
    input.addEventListener('input', () => {
      clearTimeout(h); const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      h = setTimeout(async () => {
        const my = ++seq;
        try {
          const r = await fetch(T.routes.root.replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6');
          const j = await r.json(); if (my !== seq) return;
          const items = (j.resources && j.resources.results && j.resources.results.products) || [];
          if (!items.length) { out.innerHTML = '<p class="search-pop__empty">' + esc(q) + ' — 0</p>'; return; }
          out.innerHTML = items.map((p) => {
            const img = p.featured_image && p.featured_image.url ? `<img src="${esc(p.featured_image.url)}" alt="" loading="lazy" width="56" height="56">` : '<span></span>';
            const cmp = p.compare_at_price_max && Number(p.compare_at_price_max) > Number(p.price) ? `<s>${formatMoney(String(p.compare_at_price_max))}</s>` : '';
            return `<a class="sres" href="${esc(p.url)}">${img}<span class="sres__t">${esc(p.title)}</span><span class="sres__p">${formatMoney(String(p.price))}${cmp}</span></a>`;
          }).join('') + `<a class="search-pop__all" href="${esc(T.routes.search || '/search')}?q=${encodeURIComponent(q)}&type=product">${esc(T.strings.viewAll || 'View all')}</a>`;
        } catch (err) { out.innerHTML = ''; }
      }, 220);
    });
  }

  /* Antes / después */
  function initBeforeAfter() {
    $$('[data-before-after]').forEach((el) => {
      if (el._ba) return; el._ba = true;
      const r = $('[data-ba-range]', el);
      const set = () => el.style.setProperty('--pos', r.value + '%');
      r.addEventListener('input', set); set();
    });
  }

  /* Productos recomendados (carga diferida) */
  function initRecommendations() {
    $$('product-recommendations').forEach((el) => {
      if (el._rec || !el.dataset.url) return; el._rec = true;
      const load = () => fetch(el.dataset.url).then((r) => r.ok ? r.text() : '').then((t) => {
        if (!t) return;
        const doc = new DOMParser().parseFromString(t, 'text/html');
        const src = $('product-recommendations', doc);
        if (src && src.innerHTML.trim()) el.innerHTML = src.innerHTML;
      }).catch(() => {});
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((en) => { if (en.some((x) => x.isIntersecting)) { io.disconnect(); load(); } }, { rootMargin: '600px' });
        io.observe(el);
      } else load();
    });
  }

  /* Aparecer al hacer scroll */
  function initReveal() {
    if (!document.documentElement.classList.contains('js-reveal') || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((en) => en.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('main .section, main .hero, main .marquee').forEach((s) => { if (s.getBoundingClientRect().top < window.innerHeight * 0.9) return; s.classList.add('reveal'); io.observe(s); });
  }

  // Cada módulo corre aislado: si uno falla, los demás (carrito, producto) siguen funcionando
  const safe = (fn) => { try { fn(); } catch (e) { console.warn('[theme]', fn.name || 'init', e); } };
  const bootProducts = () => $$('product-form').forEach((el) => { if (!el._pf) el._pf = new ProductForm(el); });

  function init() {
    safe(() => Cart.init());
    safe(bootProducts);
    safe(initHeader);
    safe(initCountdowns);
    safe(initAccordions);
    safe(initSliders);
    safe(initReviewSliders);
    safe(initSearch);
    safe(initFilters);
    safe(initScrollProgress);
    safe(initHotspots);
    safe(initSlideshows);
    safe(initShipSteps);
    safe(initTrack);
    safe(initBeforeAfter);
    safe(initRecommendations);
    safe(initReveal);
    // Formularios clásicos (tarjetas de producto con botón)
    document.addEventListener('submit', async (e) => {
      const f = e.target.closest('form[data-ajax-add]'); if (!f) return;
      e.preventDefault();
      try { await Cart.post(T.routes.cartAdd, { items: [{ id: Number(f.querySelector('[name=id]').value), quantity: 1 }] }); Cart.open(); } catch (err) { toast(err.message); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Editor de temas: re-iniciar solo lo de la sección recargada
  document.addEventListener('shopify:section:load', () => {
    [initSliders, initReviewSliders, initAccordions, initBeforeAfter, initRecommendations, initHotspots, initSlideshows, initShipSteps, initFilters, initSearch, bootProducts].forEach(safe);
  });
})();
